var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_3021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.95605H14.25V2.20605C14.25 1.79355 13.9125 1.45605 13.5 1.45605C13.0875 1.45605 12.75 1.79355 12.75 2.20605V2.95605H5.25V2.20605C5.25 1.79355 4.9125 1.45605 4.5 1.45605C4.0875 1.45605 3.75 1.79355 3.75 2.20605V2.95605H3C2.175 2.95605 1.5 3.63105 1.5 4.45605V16.4561C1.5 17.2811 2.175 17.9561 3 17.9561H15C15.825 17.9561 16.5 17.2811 16.5 16.4561V4.45605C16.5 3.63105 15.825 2.95605 15 2.95605ZM14.25 16.4561H3.75C3.3375 16.4561 3 16.1186 3 15.7061V6.70605H15V15.7061C15 16.1186 14.6625 16.4561 14.25 16.4561Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_3021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.706055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.4cb8f4a38176b68dff407f449cd09ac4.svg";
export { ForwardRef as ReactComponent };